/**
 * Lo que se ve mientras se pregunta al servidor quién eres: un esqueleto con la forma de la app
 * (barra superior y columnas del tablero) en lugar de un «Cargando…» suelto.
 *
 * Sigue las reglas de «Estados de carga» (docs/arquitectura/web.md): el esqueleto ocupa su lugar
 * invisible y solo aparece si la respuesta tarda más de ~300 ms, así una sesión que responde rápido
 * pasa directo al tablero (o al ingreso) sin parpadeo. Todo es decorativo; la zona lleva `aria-busy`
 * y el aviso para lectores va fuera de ella para que se anuncie.
 */
import { Esqueleto, TextoCargando } from '../../componentes/Esqueleto';
import { useMostrarTrasRetardo } from '../../componentes/useMostrarTrasRetardo';
import './SesionCargando.css';

/** Tarjetas fantasma por columna: alternar 3 y 2 se parece más a un tablero real que columnas iguales. */
const TARJETAS_POR_COLUMNA = [3, 2, 3, 2];

export function SesionCargando() {
  // Este componente solo existe mientras la sesión carga: el plazo corre desde que se monta.
  const mostrar = useMostrarTrasRetardo(true);

  return (
    <>
      <TextoCargando>Cargando tu sesión…</TextoCargando>
      <div className={`sesion-cargando${mostrar ? '' : ' carga--espera'}`} aria-busy="true">
        <div className="sesion-cargando__barra-fondo esq-caja" aria-hidden="true">
          <div className="sesion-cargando__barra">
            <span className="sesion-cargando__marca">
              <Esqueleto forma="icono" />
              <Esqueleto forma="titulo" className="sesion-cargando__nombre" />
            </span>
            <span className="sesion-cargando__pestanas">
              <Esqueleto forma="chip" />
              <Esqueleto forma="chip" />
              <Esqueleto forma="chip" />
            </span>
            <Esqueleto forma="avatar" className="sesion-cargando__avatar" />
          </div>
        </div>
        <div className="sesion-cargando__cuerpo" aria-hidden="true">
          <Esqueleto forma="titulo" className="sesion-cargando__titulo" />
          <div className="sesion-cargando__columnas">
            {TARJETAS_POR_COLUMNA.map((tarjetas, i) => (
              <div key={i} className="sesion-cargando__columna esq-caja">
                <Esqueleto forma="titulo" ancho={50} />
                {Array.from({ length: tarjetas }, (_, n) => (
                  <Esqueleto key={n} forma="bloque" />
                ))}
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}
